import * as React from 'react';

import withStyles, {
  WithStyles,
  StyleRulesCallback
} from '@material-ui/core/styles/withStyles';

import DeleteIcon from '@material-ui/icons/Delete';

import {
  Card,
  CardMedia,
  CardContent,
  CardActions,
  FormControlLabel,
  Checkbox,
  Typography as T,
  Button,
  IconButton
} from '@material-ui/core';

import { floatToString } from '../utils';

const BACKGROUND_IMG = require('./alphabackground2.jpg');

interface Props {
  kind?: string | null;
  source?: string | null;
  meanNdvi?: number | null;
  date: string;
  thumbnailUrl?: string;
  selected?: boolean;
  selectable?: boolean;
  onDownload?: () => void;
  onOpen?: () => void;
  onDelete?: () => void;
  onClick?: () => void;
  onSelect?: (
    evt: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => void;
}

const styles: StyleRulesCallback = theme => ({
  card: {
    maxWidth: 345,
    minWidth: 200,
    overflow: 'visible'
  },
  media: {
    height: 150,
    backgroundImage: `url(${BACKGROUND_IMG})`
  },
  thumbnailCover: {
    width: '100%',
    height: '100%',
    objectFit: 'cover'
  },
  thumbnailFit: {
    width: '100%',
    height: '100%',
    objectFit: 'contain'
  }
});

const CommonActions: React.SFC<Props> = (props: Props) => (
  <CardActions style={{ justifyContent: 'space-between' }}>
    {props.onOpen && (
      <Button size="small" color="primary" onClick={props.onOpen}>
        Abrir
      </Button>
    )}
    {props.onDownload && (
      <Button size="small" color="primary" onClick={props.onDownload}>
        Descargar
      </Button>
    )}
    {props.onDelete && (
      <IconButton color="default" onClick={props.onDelete}>
        <DeleteIcon style={{ fontSize: 18 }} color="action" />
      </IconButton>
    )}
  </CardActions>
);

const SelectActions: React.SFC<Props> = props => (
  <CardActions>
    <FormControlLabel
      control={<Checkbox checked={props.selected} onChange={props.onSelect} />}
      label="seleccionar"
    />
  </CardActions>
);

const DocumentCard: React.SFC<Props & WithStyles> = props => (
  <Card className={props.classes.card} onClick={props.onClick}>
    {props.thumbnailUrl &&
      <CardMedia className={props.classes.media}>
        <img
          className={
            props.kind === 'scene'
              ? props.classes.thumbnailCover
              : props.classes.thumbnailFit
          }
          src={props.thumbnailUrl}
        />
      </CardMedia>
    }
    <CardContent>
      <T variant="headline" component="h4">
        {props.date}
      </T>
      {props.kind && <T variant="subheading">tipo: {props.kind}</T>}
      {props.source && <T variant="subheading">fuente: {props.source}</T>}
      {props.meanNdvi && (
        <T variant="subheading">NDVI: {floatToString(props.meanNdvi, 2)}</T>
      )}
    </CardContent>
    {props.selectable ? (
      <SelectActions {...props} />
    ) : (
      <CommonActions {...props} />
    )}
  </Card>
);

export default withStyles(styles)(DocumentCard);



// WEBPACK FOOTER //
// ./src/components/DocumentCard.tsx